export default __webpack_public_path__ + "static/garden_design32-bcb3ba21ed014ecab85a144f46a58e5c.webp";